import React from 'react';

const RefreshContext = React.createContext(3);
export const RefreshContextProvider = RefreshContext.Provider;
export default RefreshContext;
